module.exports = __webpack_public_path__ + "images/emoji/dizzy_face.741549a08b78335e847d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dizzy_face.png
// module id = z5I8
// module chunks = 1